import Decimal from 'decimal.js';

import { types as sdkTypes } from './sdkLoader';

const { Money } = sdkTypes;

/**
 * Sums lineTotals for line items that count toward customer payin (matches transaction payinTotal).
 * Same rule as server `calculateTotalForCustomer` in api-util/lineItemHelpers.
 *
 * @param {Array<{ includeFor?: string[], lineTotal?: Money, reversal?: boolean }>|null|undefined} lineItems
 * @returns {Money|null}
 */
export const customerPayinTotalFromLineItems = lineItems => {
  if (!Array.isArray(lineItems) || lineItems.length === 0) {
    return null;
  }

  let sum = new Decimal(0);
  let currency = null;

  for (const li of lineItems) {
    if (
      li.reversal ||
      !Array.isArray(li.includeFor) ||
      !li.includeFor.includes('customer') ||
      !(li.lineTotal instanceof Money)
    ) {
      continue;
    }
    if (currency == null) {
      currency = li.lineTotal.currency;
    } else if (currency !== li.lineTotal.currency) {
      return null;
    }
    sum = sum.plus(li.lineTotal.amount);
  }

  if (currency == null) {
    return null;
  }

  const rounded = sum.toDecimalPlaces(0, Decimal.ROUND_HALF_UP).toNumber();
  return new Money(rounded, currency);
};
